import { render, staticRenderFns } from "./info1.vue?vue&type=template&id=e65c6032&scoped=true"
import script from "./info1.vue?vue&type=script&lang=js"
export * from "./info1.vue?vue&type=script&lang=js"
import style0 from "./info1.vue?vue&type=style&index=0&id=e65c6032&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e65c6032",
  null
  
)

export default component.exports